import { useEffect, useState } from "react"
import BranchCard_activityDay from "./BranchCard_activityDay";

export default function BranchCard_activity({branch, index, onActivityChange}) {
  const [weekData, setWeekData] = useState(branch.week || []);

  // Wait for a triger from child => when child got trigered he will inform
  // His parent(this component) which get the child dayIndex and the updated data after changes
  // This triger will change here only the dayIndex position at weekData with the new data,
  // Then inform parent with updated week data
  const handleDayChange = (dayIndex, updatedDay) => {
    const updatedWeek = [...weekData];
    updatedWeek[dayIndex] = updatedDay;
    setWeekData(updatedWeek);
  };

  // Inform parent (BranchCard) whenever weekData changes
  useEffect(() => {
    onActivityChange(weekData);
  }, [weekData]);

  const deployActivity = (week)=>{
    return week.map((day, inx)=>{
      return <BranchCard_activityDay key={`branchCard_${index}_day_${inx}`} cardIndex={index} dayIndex={inx} day={day} setDayData={handleDayChange}/>
    })
  }
  return (
    <div style={{marginBottom:"20px"}}>
      {deployActivity(branch.week)}
    </div>
  )
}
